var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    {
      staticClass: "elevation-12 toast-item py-2 px-1",
      attrs: {
        value: true,
        type: _vm.type || null,
        color: _vm.color,
        id: _vm.id
      }
    },
    [
      _vm.timeout
        ? _c(
            "v-progress-circular",
            {
              staticClass: "btn-progress",
              attrs: {
                absolute: "",
                right: "",
                color: "black",
                size: 36,
                width: 4,
                rotate: -90,
                value: _vm.progress
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { small: "", icon: "", flat: "", color: "black" },
                  on: {
                    click: function($event) {
                      return _vm.clear()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("cancel")])],
                1
              )
            ],
            1
          )
        : _c(
            "v-btn",
            {
              attrs: {
                small: "",
                icon: "",
                flat: "",
                absolute: "",
                right: "",
                color: "black"
              },
              on: {
                click: function($event) {
                  return _vm.clear()
                }
              }
            },
            [_c("v-icon", [_vm._v("cancel")])],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "title mb-2 mr-5 ml-2" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "safe-html",
            rawName: "v-safe-html.allowLinks",
            value: _vm.content,
            expression: "content",
            modifiers: { allowLinks: true }
          }
        ]
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("v-progress-linear", {
            attrs: { color: "black", height: 2, indeterminate: true }
          })
        : _vm.timeout
        ? _c("v-progress-linear", {
            attrs: { color: "black", height: 2, value: _vm.progress }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d0616b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0616b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/App_toaster_item.vue
// module id = null
// module chunks = 